import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PitchFlipCard from "@/components/PitchFlipCard";

const categories = ["All", "AI-Powered", "FinTech", "HealthTech", "CleanTech", "SaaS", "AgriTech", "PropTech"];

export default function Pitches() {
  const [pitches, setPitches] = useState([]);
  const [cat, setCat] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/pitches", { params: { category: cat } }).then((r) => setPitches(r.data)).finally(() => setLoading(false));
  }, [cat]);

  return (
    <main className="relative pt-28 pb-24 max-w-7xl mx-auto px-4 sm:px-6">
      <div className="noise-overlay" />
      <div className="text-left mb-10">
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">
          Browse <span className="gold-gradient-text">Pitches</span>
        </h1>
        <p className="mt-3 text-zinc-500 text-sm md:text-base max-w-lg">One-minute video pitches from vetted founders. Watch, flip the card for the full deck, and engage.</p>
      </div>
      <div className="flex gap-2.5 overflow-x-auto hide-scrollbar mb-10" data-testid="pitch-category-filters">
        {categories.map((c) => (
          <button
            key={c}
            data-testid={`filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            onClick={() => setCat(c)}
            className={`shrink-0 px-4 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
              cat === c ? "bg-[#F5B301] text-black border-[#F5B301]" : "border-white/15 text-zinc-400 hover:border-[#F5B301]/50 hover:text-[#F5B301]"
            }`}
          >
            {c}
          </button>
        ))}
      </div>
      {loading ? (
        <p className="text-zinc-500 text-sm" data-testid="pitches-loading">Loading pitches…</p>
      ) : pitches.length === 0 ? (
        <p className="text-zinc-500 text-sm" data-testid="pitches-empty">No pitches in this category yet.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10" data-testid="pitches-grid">
          {pitches.map((p) => (
            <PitchFlipCard key={p.id} pitch={p} />
          ))}
        </div>
      )}
    </main>
  );
}
